// eslint-disable-next-line no-shadow
export var DragObjectType;

(function (DragObjectType) {
  DragObjectType["Node"] = "node";
  DragObjectType["NodeData"] = "nodedata";
})(DragObjectType || (DragObjectType = {}));